export default {
  bouyguesIcon: {
    id: 'checkout_services_bouygues_login_form_bouygues_icon',
    defaultMessage: 'Bouygues icon',
  },
}
